import React from 'react';
import cx from 'classnames';

import { TickIcon } from '@motorway/mw-highway-code';

import styles from './ProgressStepsIndicator.scss';

type ShowLabels = 'desktop' | 'none' | 'always';

type Step = {
  completed?: boolean;
  id: number;
  title: React.ReactNode;
};

type ProgressStepsIndicatorProps = {
  currentStep: number;
  showLabels?: ShowLabels;
  steps: Step[];
};

export const ProgressStepsIndicator = ({ currentStep, showLabels = 'desktop', steps }: ProgressStepsIndicatorProps) =>
  <ol className={styles.progressStepsIndicator}>
    {steps.map((step, index) => {
      const { completed, id, title } = step;

      return <li
        key={id}
        aria-current={index === currentStep}
        className={cx(styles.step, {
          [styles.completed]: completed,
        })}
      >
        <span className={styles.title} data-visibility={showLabels}>
          {title}
        </span>
        <div className={styles.indicator}>
          <div className={styles.marker}>
            {step.completed ? <TickIcon /> : index + 1}
          </div>
        </div>
      </li>;
    })}
  </ol>;
